import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { createEntityAdapter } from '../../../helpers/create-entity-adapter';
import { Warehouse } from '../../../interfaces/warehouse.interface';
import { GetWarehousesResponse } from '../interfaces/get-warehouses';

export interface WarehouseState {
  warehouses: {
    ids: string[];
    entities: Record<string, Warehouse>;
  };
  warehouse: Warehouse | null;
  errorCode: number | null;
}

const initialState: WarehouseState = {
  warehouses: {
    ids: [],
    entities: {},
  },
  warehouse: null,
  errorCode: null,
};

const warehouseAdapter = createEntityAdapter<Warehouse>((store: Warehouse) => store.id);

const warehouseSlice = createSlice({
  name: 'warehouse',
  initialState,
  reducers: {
    getWarehousesInitApiAction: (state) => {
      state.errorCode = null;
    },
    getWarehousesSuccessApiAction: (
      state,
      action: PayloadAction<GetWarehousesResponse>
    ) => {
      warehouseAdapter.addMany(action.payload.warehouses, state.warehouses);
    },
    getWarehousesFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postWarehouseInitApiAction: (state) => {
      state.errorCode = null;
    },
    postWarehouseSuccessApiAction: () => {},
    postWarehouseFailuireApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putWarehouseInitApiAction: (state) => {
      state.errorCode = null;
    },
    putWarehouseSuccessApiAction: () => {},
    putWarehouseFailuireApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    deleteWarehouseInitApiAction: () => {},
    deleteWarehouseSuccessApiAction: () => {},
    deleteWarehouseFailuireApiAction: () => {},
    setWarehouseAction: (state, action: PayloadAction<Warehouse | null>) => {
      state.warehouse = action.payload;
    },
  },
});

export const {
  getWarehousesInitApiAction,
  getWarehousesSuccessApiAction,
  getWarehousesFailureApiAction,
  postWarehouseInitApiAction,
  postWarehouseSuccessApiAction,
  postWarehouseFailuireApiAction,
  putWarehouseInitApiAction,
  putWarehouseSuccessApiAction,
  putWarehouseFailuireApiAction,
  deleteWarehouseInitApiAction,
  deleteWarehouseSuccessApiAction,
  deleteWarehouseFailuireApiAction,
  setWarehouseAction,
} = warehouseSlice.actions;

export default warehouseSlice.reducer;
